import { useLoadScript } from '@react-google-maps/api';

const libraries = ['visualization', 'places'];

export const loadMapScript = ({ mapAPIKey }) => useLoadScript({
  googleMapsApiKey: mapAPIKey,
  libraries
});